import { createContext } from "react";
import { EntryStore } from "../../store";

export const EntryContext = createContext<EntryStore | null>(null);
